import { render, staticRenderFns } from "./BarChartAbandonedReport.vue?vue&type=template&id=4ccc4a97&scoped=true"
import script from "./BarChartAbandonedReport.vue?vue&type=script&lang=js"
export * from "./BarChartAbandonedReport.vue?vue&type=script&lang=js"
import style0 from "./BarChartAbandonedReport.vue?vue&type=style&index=0&id=4ccc4a97&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ccc4a97",
  null
  
)

export default component.exports